module.exports = __webpack_public_path__ + "img/121_google.4a1a0c41.gif";